import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { Footer, Header, SurveyNagBanner } from 'molecules';
import { SurveyNagModal, UnpaidInvoicesModal } from 'organisms';

import { Colors } from 'context';
import { useCareerShell } from 'core/hooks/Routes/useActiveMenu';
import { desktop } from 'services/ui';

export interface IMainTemplate {
  children: React.ReactElement;
}

// Здесь БЫЛ предохранитель `useEffect(() => body.classList.remove('no--scroll'))`
// без массива зависимостей. Он не помогал (срабатывал на рендер САМОГО шаблона,
// а состояние скачивания живёт в дочерней странице) и при этом вредил: любой
// ререндер шаблона разблокировал бы фон под открытой модалкой. Блокировку
// теперь ведёт сама `atoms/Modal` — счётчиком, в cleanup эффекта.
export const MainTemplate = memo(({ children }: IMainTemplate) => {
  const wide = useCareerShell();
  return (
    <Paper>
      <Header />

      <ContentWrapper $wide={wide}>
        {/* ТЗ 0074: баннер должника (0003) снят — приостановленному студенту
            красную область показывает сама страница фактур. */}
        <SurveyNagBanner />
        {children}
      </ContentWrapper>

      {/* Порядок важен: фактурный поп-ап раньше опросного (ТЗ 0074). */}
      <UnpaidInvoicesModal />
      <SurveyNagModal />

      <Footer />
    </Paper>
  );
});

export const Paper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${Colors.white};
`;

const ContentWrapper = styled.div<{ $wide: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 1110px;
  min-height: calc(100vh - 345px);
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: transparent;
  z-index: 10;
  padding: 0 20px;

  ${desktop} {
    padding: 0;
  }

  /* Карьерный раздел: колонки 1110 нет, поля держит сама оболочка раздела. */
  ${({ $wide }) =>
    $wide &&
    css`
      max-width: none;
      padding: 0;
    `}
`;
